module.exports = __webpack_public_path__ + "static/media/rentabilidade.8dcfa947.png";